import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-fca4c36c")

_pushScopeId("data-v-fca4c36c")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Request Registration Renewal ")
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "field" }
const _hoisted_4 = { class: "field" }
const _hoisted_5 = /*#__PURE__*/_createVNode("label", { for: "renewalComments" }, " Comments ", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "help is-danger" }, "(required)", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_field_validate = _resolveComponent("field-validate")
  const _component_modal_dialog = _resolveComponent("modal-dialog")

  return (_openBlock(), _createBlock(_component_modal_dialog, {
    onDone: _cache[2] || (_cache[2] = ($event: any) => (_ctx.resolveDialogAction($event))),
    active: _ctx.isVisible
  }, {
    title: _withId(() => [
      _hoisted_1,
      (_ctx.registrationNumber)
        ? (_openBlock(), _createBlock("span", _hoisted_2, "for " + _toDisplayString(_ctx.registrationNumber), 1))
        : _createCommentVNode("", true)
    ]),
    body: _withId(() => [
      _createVNode("div", _hoisted_3, [
        _createVNode("form", { id: _ctx.formId }, [
          _createVNode("div", _hoisted_4, [
            _hoisted_5,
            _hoisted_6,
            _withDirectives(_createVNode("textarea", {
              placeholder: "Renewal comments",
              name: "renewalComments",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.renewalComments = $event))
            }, null, 512), [
              [_vModelText, _ctx.renewalComments]
            ]),
            _createVNode(_component_field_validate, {
              for: "renewalComments",
              required: "",
              "max-length": 250
            })
          ])
        ], 8, ["id"])
      ])
    ]),
    _: 1
  }, 8, ["active"]))
})